import { useState } from 'react';
import { SEOHead } from '../components/SEOHead';
import { GridOverlay, LevelIndicator, FocusIndicator } from '@pixcapture/shared';
import { CameraControlBar } from '../components/CameraControlBar';
import { HistogramOverlay } from '../components/HistogramOverlay';
import { ZoomControl } from '../components/ZoomControl';

export default function AppCamera() {
  const [gridEnabled, setGridEnabled] = useState(false);
  const [histogramEnabled, setHistogramEnabled] = useState(false);
  const [zoom, setZoom] = useState(1);
  const orientation = 'portrait';
  const safeAreaTop = 59;
  const safeAreaBottom = 34;

  return (
    <div className="relative w-full h-screen bg-black overflow-hidden">
      <SEOHead title="Kamera – pixcapture.app" description="Professionelle Immobilienfotos aufnehmen" path="/app/camera" />

      {/* Camera Preview Placeholder */}
      <div className="absolute inset-0 flex items-center justify-center">
        <p className="text-white/50">Camera Preview</p>
      </div>

      {/* Overlays */}
      {gridEnabled && <GridOverlay />}
      <LevelIndicator pitch={0} roll={0} />
      <FocusIndicator x={50} y={50} visible={true} />

      {histogramEnabled && (
        <HistogramOverlay
          orientation={orientation}
          visible={true}
          safeAreaTop={safeAreaTop}
          safeAreaBottom={safeAreaBottom}
        />
      )}

      <ZoomControl
        orientation={orientation}
        safeAreaTop={safeAreaTop}
        safeAreaBottom={safeAreaBottom}
        currentZoom={zoom}
        onZoomChange={setZoom}
      />

      <CameraControlBar
        orientation={orientation}
        safeAreaBottom={safeAreaBottom}
        gridEnabled={gridEnabled}
        histogramEnabled={histogramEnabled}
        onFormatClick={() => console.log('Format')}
        onRoomClick={() => console.log('Room')}
        onShutterClick={() => console.log('Shutter')}
        onGridToggle={() => setGridEnabled(!gridEnabled)}
        onHistogramToggle={() => setHistogramEnabled(!histogramEnabled)}
        onSettingsClick={() => console.log('Settings')}
      />
    </div>
  );
}
